module.exports = __webpack_public_path__ + "static/media/stellairLogo-32px.767f8a50.svg";